module.exports = __webpack_public_path__ + "fabf01fe78a0c7f6d6cdcaade82d8559.jpg";